import { Tooltip } from "antd";
import React from "react";

const DownloadIcon = ({
  width = 18,
  height = 18,
  color = "#ffffff",
  mainColor = "",
  title = "Download",
}) => {
  const strokeColor = mainColor || color;

  return (
    <Tooltip title={<p className="text-[11px]">{title}</p>} color={strokeColor}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none" // Don't fill entire SVG, keep it clean
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 4V17M12.5 17L7 12.2105M12.5 17L18 12.2105"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 21H19"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Tooltip>
  );
};

export default DownloadIcon;
